import EditorViewState from '../store/schema/EditorViewState';
import setIsDirty from '../actions/setIsDirty';
import setCachedSelection from '../actions/setCachedSelection';
import setShouldUpdateContentOnDispose from '../actions/setShouldUpdateContentOnDispose';
import setAdditionalProps from '../actions/setAdditionalProps';
import updateContent from '../actions/updateContent';
import { EditorPlugin, IEditor, PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default class ViewStateManagePlugin implements EditorPlugin {
    private editor: IEditor;
    private keyStrokeCount: number;

    constructor(
        private viewState: EditorViewState,
        private updateOnKeyPress: boolean,
        private updateOnDispose: boolean
    ) {}

    getName() {
        return 'ViewStateManage';
    }

    initialize(editor: IEditor) {
        this.editor = editor;
        this.keyStrokeCount = this.viewState.keyStrokeCount;
        setShouldUpdateContentOnDispose(this.viewState, this.updateOnDispose);
    }

    dispose() {
        this.editor = null;
    }

    onPluginEvent(e: PluginEvent) {
        if (e.eventType == PluginEventType.Input) {
            if (this.updateOnKeyPress) {
                this.updateContentToViewState();
            } else if (!this.viewState.isDirty) {
                setIsDirty(this.viewState, true /*isDirty*/);
            }
            this.keyStrokeCount++;
            this.clearCachedSelection();
        } else if (e.eventType == PluginEventType.ContentChanged) {
            this.clearCachedSelection();
        } else if (
            e.eventType == PluginEventType.BeforeDispose &&
            this.viewState.shouldUpdateContentOnDispose
        ) {
            this.updateContentToViewState();

            if (this.editor.getSelectionRange()) {
                setCachedSelection(this.viewState, this.editor.getSelectionPath());
            }
        } else if (e.eventType == PluginEventType.ExtractContentWithDom) {
            setAdditionalProps(this.viewState, this.getTextDirection(), this.keyStrokeCount);
        }
    }

    private updateContentToViewState(isInitializing?: boolean) {
        if (this.editor) {
            updateContent(this.viewState, this.editor.getContent(), isInitializing);
        }
    }

    private getTextDirection() {
        const dir = this.editor?.getEditorDomAttribute('dir')?.toLowerCase();
        return dir == 'ltr' || dir == 'rtl' ? dir : null;
    }

    private clearCachedSelection() {
        if (this.viewState.selectionPath) {
            setCachedSelection(this.viewState, null);
        }
    }
}
